import { SvgXml } from 'react-native-svg'

// Figma 2174:13275, mirrored from deposit-chevron.svg so Metro needs no SVG loader.
const SVG =
  '<svg width="19" height="24" viewBox="255 177 19 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M256.812 189.539C256.824 189.059 256.988 188.66 257.374 188.285L266.398 179.461C266.691 179.156 267.054 179.016 267.499 179.016C268.378 179.016 269.081 179.707 269.081 180.586C269.081 181.02 268.906 181.418 268.589 181.734L260.574 189.527L268.589 197.344C268.906 197.66 269.081 198.047 269.081 198.492C269.081 199.371 268.378 200.074 267.499 200.074C267.066 200.074 266.691 199.922 266.398 199.617L257.374 190.793C256.988 190.418 256.812 190.02 256.812 189.539Z" fill="currentColor"/></svg>'

export function DepositChevronIcon({ color }: { color: string }) {
  return (
    <SvgXml xml={SVG.replace(/currentColor/g, color)} width={19} height={24} />
  )
}
